import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -10
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section className="w-full bg-gradient-to-b from-cream to-warmWhite py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h2 className="font-heading text-3xl sm:text-4xl text-charcoal" data-id="element-4">
            ¿Es para ti?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5">
          {/* For whom */}
          <motion.div className="bg-warmWhite rounded-3xl p-8 shadow-warm border border-sage-100" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} data-id="element-6">
            <h3 className="font-heading text-2xl text-charcoal mb-6 flex items-center gap-2" data-id="element-7">
              <span className="w-8 h-8 bg-sage-100 rounded-full flex items-center justify-center" data-id="element-8">
                <CheckCircleIcon className="w-5 h-5 text-sage" data-id="element-9" />
              </span>
              Para quién es
            </h3>

            <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-10">
              <motion.li className="flex items-start gap-3" variants={itemVariants} data-id="element-11">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-12" />
                <span className="font-body text-warmGray" data-id="element-13">
                  Madres primerizas con bebés de 0 a 12 meses.
                </span>
              </motion.li>
              <motion.li className="flex items-start gap-3" variants={itemVariants} data-id="element-14">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-15" />
                <span className="font-body text-warmGray" data-id="element-16">
                  Mujeres que sienten que el agotamiento está afectando su salud
                  mental.
                </span>
              </motion.li>
              <motion.li className="flex items-start gap-3" variants={itemVariants} data-id="element-17">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-18" />
                <span className="font-body text-warmGray" data-id="element-19">
                  Padres que buscan una solución humana, compasiva y sin métodos
                  crueles.
                </span>
              </motion.li>
              <motion.li className="flex items-start gap-3" variants={itemVariants} data-id="element-20">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-21" />
                <span className="font-body text-warmGray" data-id="element-22">
                  Cualquier madre que necesite volver a sentirse dueña de su
                  tiempo y su descanso.
                </span>
              </motion.li>
            </motion.ul>
          </motion.div>

          {/* Not for whom */}
          <motion.div className="bg-warmWhite rounded-3xl p-8 shadow-warm border border-terracotta-100" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-23">
            <h3 className="font-heading text-2xl text-charcoal mb-6 flex items-center gap-2" data-id="element-24">
              <span className="w-8 h-8 bg-terracotta-100 rounded-full flex items-center justify-center" data-id="element-25">
                <XCircleIcon className="w-5 h-5 text-terracotta" data-id="element-26" />
              </span>
              Para quién NO es
            </h3>

            <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-27">
              <motion.li className="flex items-start gap-3" variants={itemVariants} data-id="element-28">
                <XCircleIcon className="w-5 h-5 text-warmGray flex-shrink-0 mt-0.5" data-id="element-29" />
                <span className="font-body text-warmGray" data-id="element-30">
                  Personas que buscan métodos rápidos basados en dejar al bebé
                  llorar solo.
                </span>
              </motion.li>
              <motion.li className="flex items-start gap-3" variants={itemVariants} data-id="element-31">
                <XCircleIcon className="w-5 h-5 text-warmGray flex-shrink-0 mt-0.5" data-id="element-32" />
                <span className="font-body text-warmGray" data-id="element-33">
                  Padres que no están dispuestos a cambiar la rutina ambiental
                  de la casa.
                </span>
              </motion.li>
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}